import { useComplexState } from 'hook/helper.hook';
import {
  getSelectedAutoLoanRefi,
  setSelectedAutoLoanRefi,
} from 'helpers/localstorage';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';

import { sortList, sortAttr, sortTypeString } from 'helpers/autoLoan.helper';
import { getAutoloanClickTrackingAttributes } from 'helpers/tracking.helpers';

export const useAutoRefinanceMarketplace = ({
  eventHandler,
  setCommonStates,
  getAutoRefinance,
  setRefinanceOffers,
  refinanceOffers,
  autoLoanAccounts,
  moduleName,
}) => {
  const checkIfCacheLoanAccountExist = () => {
    const localAccount = getSelectedAutoLoanRefi();

    if (autoLoanAccounts?.length === 1 || !localAccount) {
      return 1;
    } else {
      return localAccount;
    }
  };

  const [state, setState] = useComplexState({
    refinanceAccount: checkIfCacheLoanAccountExist(),
    refinanceReason: null,
    showSearchCriteria: false,
    sortListOpen: false,
    currentSortType: sortList[0],
    filterTags: null,
  });

  const setCurrentSortType = e => {
    setState({
      currentSortType: e,
    });
  };

  const onRemoveTagFilter = key => {
    const defaultValue = {
      sortBy: sortList[0],
    };
    let updatedKey = { [key]: { value: defaultValue[key], label: null } };

    switch (key) {
      case 'sortBy':
        setState({
          filterTags: {
            ...state.filterTags,
            ...updatedKey,
          },
          currentSortType: sortList[0],
        });

        getAutoRefinance({
          currentSortType: sortList[0],
          refinanceAccount: autoLoanAccounts[state.refinanceAccount - 1],
        });

        break;
      default:
        break;
    }
  };

  const onApplyFilter = () => {
    const tags = {};

    if (state.currentSortType !== sortList[0]) {
      tags.sortBy = {
        value: state.currentSortType,
        label: `Sort: ${state.currentSortType}`,
      };
    }

    setState({ filterTags: tags });
    setCommonStates({ showModal: false });
    getAutoRefinance({
      currentSortType: state.currentSortType,
      refinanceAccount: autoLoanAccounts[state.refinanceAccount - 1],
    });
  };

  const onSortBy = value => {
    const sortedOffers = refinanceOffers.sort((a, b) => {
      return a[sortAttr[value]] - b[sortAttr[value]];
    });

    const trackingAttributes = getAutoloanClickTrackingAttributes({
      clickType: sortTypeString[value],
      vertical: AUTO_LOAN_VERTICAL,
      module: moduleName,
    });

    setRefinanceOffers(sortedOffers);
    setState({ currentSortType: value });
    eventHandler(CLICK, trackingAttributes);
  };

  const handleAccountRadioClick = e => {
    setState({ refinanceAccount: e.target.value });
  };

  const onSeeAutoRefinanceOffers = () => {
    const trackingAttributes = getAutoloanClickTrackingAttributes({
      clickType: 'Show Auto Loans',
      vertical: AUTO_LOAN_VERTICAL,
      module: moduleName,
    });

    eventHandler(CLICK, trackingAttributes);

    if (autoLoanAccounts.length > 1) {
      setSelectedAutoLoanRefi(state.refinanceAccount);
    }

    getAutoRefinance({
      currentSortType: state.currentSortType,
      refinanceAccount: autoLoanAccounts[state.refinanceAccount - 1],
    });
  };
  return {
    autoLoanAccounts,
    state,
    handleAccountRadioClick,
    onSeeAutoRefinanceOffers,
    sortList,
    onApplyFilter,
    onSortBy,
    onRemoveTagFilter,
    setCurrentSortType,
  };
};
